"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var invariant_1 = __importDefault(require("invariant"));
var mergeOperations = function (operations) {
    var feeOp = operations.find(function (op) { return op.type === "FEES"; });
    var otherOps = operations.filter(function (op) { return op !== feeOp; });
    if (otherOps.length === 0) {
        (0, invariant_1["default"])(feeOp, "fee op is necessary if no other ops exists");
        return feeOp;
    }
    var union = __assign({}, otherOps[0]);
    // remove the "-0" part
    union.id = union.id.split("-").slice(0, 3).join("-");
    if (feeOp) {
        union.fee = feeOp.value;
        if (union.type === "OUT") {
            union.value = union.value.plus(feeOp.value);
        }
        else {
            union.value = feeOp.value;
        }
    }
    var extra = __assign({}, union.extra);
    delete extra.id;
    // accumulate validators
    if (extra.validators) {
        extra.validators = otherOps.reduce(function (validators, op) {
            return validators.concat((op.extra && op.extra.validators) || []);
        }, []);
    }
    union.extra = extra;
    return union;
};
exports["default"] = mergeOperations;
//# sourceMappingURL=libcore-mergeOperations.js.map